import React, { useEffect, useState } from "react";
import { Button, Image, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { apiRecupEspacesGrantedColidee } from "../../../api/ApiColidee";
import ComponentLoader from "../../layout/ComponentLoader";
import { BiMessageDetail } from "react-icons/bi";
import { toDateTimeFR } from "../../../utils/datesHeures";

function renvoiIdEspace(url) {
  const regex = /(https:\/\/colidee.com\/)/g;
  const found = url.match(regex);
  if (found) {
    let idEspace = url.replace("https://colidee.com/", "");
    idEspace = idEspace.split("p").filter((element) => !element.match("o"));
    return idEspace;
  }
  return false;
}

const ComponentColideeButtonEspaces = (props) => {
  let { espacesColideeOrgunit, emplacement, etiquetteAnimateur } = props;
  const { t } = useTranslation();
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [showDetailActu, setShowDetailActu] = useState(false);
  const [loader, setLoader] = useState(true);
  const [espaces, setEspaces] = useState([]);

  const openModal = () => {
    setShowDetailActu(true);
  };

  const closeModal = () => {
    setShowDetailActu(false);
  };

  const recupGlobal = async () => {
    var espacesSouhaites = [];
    const form = new FormData();

    espacesColideeOrgunit.map(
      (lien) => (espacesSouhaites = espacesSouhaites.concat(renvoiIdEspace(lien.url)))
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);
    form.append("espacesSouhaites", espacesSouhaites.join(","));
    const resEspaces = await apiRecupEspacesGrantedColidee(ReduxToken, form);
    if (resEspaces.data) {
      setEspaces(resEspaces.data);
    }
    setLoader(false);
  };

  useEffect(() => {
    if (showDetailActu) recupGlobal();
  }, [showDetailActu]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Button className="buttonCard" onClick={openModal}>
        {emplacement === "detailOrgunit"
          ? etiquetteAnimateur
            ? t("public.boutons.je_anime")
            : t("public.boutons.partager_idee")
          : t("public.boutons.je_contribue")}
      </Button>

      <Modal size="lg" show={showDetailActu} onHide={closeModal} className="modalDetailEspaces">
        <Modal.Header closeButton>
          <Modal.Title>{t("public.componentEspace.modalTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!loader && espaces.length === 0 && <>{t("public.componentEspace.noAccess")}</>}
          <pre>
            {loader && <ComponentLoader />}

            {!loader && espaces.length > 0 && (
              <>
                {espaces.map((espace, index) => (
                  <a
                    href={
                      process.env.REACT_APP_URL_COLIDEE +
                      "o" +
                      espace.id_entreprise +
                      "p" +
                      espace.id_plateforme
                    }
                    target="_blank"
                    rel="noreferrer"
                    key={"secondaire" + index}
                    className="d-flex flex-nowrap    mb-3"
                  >
                    <Image src={espace.picture} className="m-1" />
                    <div className="flex-grow-1">
                      {espace.nom}
                      <div className="categorieArticles">
                        <span className="">{toDateTimeFR(espace.dateDerniereContrib)}</span>
                        <br />
                        <BiMessageDetail size="1.5em" /> {espace.NbrContributions}
                      </div>
                    </div>
                  </a>
                ))}
              </>
            )}
          </pre>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ComponentColideeButtonEspaces;
